// extracted by mini-css-extract-plugin
module.exports = {"info":"_a2f9a37","hide":"_7477b5c"};